import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import moment from 'moment'

import RouteLayout from '../../RouteLayout'
import Spinner from '../../common/Spinner'
import { eduCommissionsGetActions } from '../../../redux/reducers/EduCommissions/eduCommissionsReducer'
import styles from './styles.module.css'

const formatDate = (v) => v ? moment(v, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY') : ''

const FIELDS = [
  { key: 'organizationName', label: 'Образовательная организация', format: v => v || '—' },
  { key: 'start_date',       label: 'Дата начала',                  format: formatDate },
  { key: 'end_date',         label: 'Дата окончания',               format: formatDate },
  { key: 'phone',            label: 'Телефон',                      format: v => v || '—' },
]

const Current = () => {
  const { id } = useParams()
  const dispatch = useDispatch()

  const data = useSelector(state => state.eduCommissions.current.data)
  const members = useSelector(state => state.eduCommissions.current.members)
  const loader = useSelector(state => state.eduCommissions.loader)

  useEffect(() => {
    dispatch(eduCommissionsGetActions.eduCommissionsGetRequestStart({ id }))
  }, [dispatch, id])

  return (
    <RouteLayout title={'Аттестационная комиссия ОО'}>
      {loader || !data
        ? <Spinner />
        : (
          <>
            <div className={styles.infoBlock}>
              {FIELDS.map(({ key, label, format }) => (
                <div key={key} className={styles.infoRow}>
                  <span className={styles.infoLabel}>{label}</span>
                  <span className={styles.infoValue}>{format(data[key])}</span>
                </div>
              ))}
            </div>

            <div className={styles.membersBlock}>
              <div className={styles.membersHeader}>Состав комиссии</div>
              <ul className={styles.membersList}>
                {members.map(m => (
                  <li key={m.mid} className={styles.memberItem}>
                    <span>
                      {m.fio}
                      {m.absent === 1 && (
                        <span className={styles.memberAbsent}> &nbsp;— отсутствовал</span>
                      )}
                    </span>
                    <span className={styles.memberPosition}>{m.position}</span>
                  </li>
                ))}
                {!members.length && (
                  <li className={styles.memberItem}>
                    <span className={styles.memberPosition}>Участники отсутствуют</span>
                  </li>
                )}
              </ul>
            </div>
          </>
        )
      }
    </RouteLayout>
  )
}

export default Current
